import React, { useEffect, useState } from "react";
import s from "./Salvta.module.css";
//assets
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import masiveDistributionServices from "../../../../api/delivery/masiveDistribution";
import deliveryServices from "../../../../api/delivery/DeliveryService";
import Brightness1Icon from '@mui/icons-material/Brightness1';

import Pager from "../../../Shared/Pagination/Pagination";
import { dateFormats } from "../../../../helpers/convertDate";
//materialUi
import Grid from "@mui/material/Grid"
import Button from "@mui/material/Button"
import Tooltip from "@mui/material/Tooltip"
import CircularProgress from "@mui/material/CircularProgress"
import TableContainer from "@mui/material/TableContainer"
import Table from "@mui/material/Table"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableCell from "@mui/material/TableCell"
import TableBody from "@mui/material/TableBody"
import SellIcon from "@mui/icons-material/Sell";
import UploadRoundedIcon from "@mui/icons-material/UploadRounded";
import UploadModal from "./UploadModal";
import DetailSalvta from "./Detail";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import Swal from "sweetalert2";
import useTranslationException from "../../../../helpers/exceptions";
// Utils
import ConciliationModal from "./ConciliationModal/index";
import LoopIcon from '@mui/icons-material/Loop';
import IconButton from "@mui/material/IconButton";

const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: ".9rem",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

// ========================== | ARCHIVOS SALVTA | ==============================

const ArchivosSalvta = () => {
  const dates = dateFormats();
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const { textColor } = useSelector((state) => state.local);

  //Estados
  const [open, setOpen] = useState(false);
  const [conciliationModalData, setConciliationModalData] = useState({
    open: false,
    data: undefined
  })
  const [detail, setDetail] = useState({
    status: false,
    data: {},
  });
  const [items, setItems] = useState([]);
  const [loadingDelete, setLoadingDelete] = useState({
    id: 0,
    status: false,
  });

  //Paginado
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [pageCustom, setPageCustom] = useState(1);
  const [sort, setSort] = useState({
    criteria: "DESC",
    field: "processDate",
  });

  const getFiles = () => {
    setLoading(true);
    masiveDistributionServices
      .getAllVtaFiles(page, pageSize, sort) //Cambiar a endpoints Salvta
      .then((res) => {
        setItems(res.content);
        setTotalPages(res.totalPages);
      })
      .then(() => setLoading(false))
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        );
        setLoading(false);
      });
  };

  const handleSort = (item) => {
    setSort((prev) => ({
      criteria:
        prev.field === item
          ? prev.criteria === "DESC"
            ? "ASC"
            : "DESC"
          : "DESC",
      field: item,
    }));
  };

  const handleDetail = (item) => {
    setDetail({
      status: true,
      data: item,
    });
  };

  const handleDelete = (item) => {
    setLoadingDelete({
      id: item.id,
      status: true,
    });
    Swal.fire({
      title: `${t("deleteFile")}: ${item.fileName}`,
      text: `${t("deleteTarascaText")}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00A36C",
      cancelButtonColor: "#d33",
      confirmButtonText: t("confirm"),
      cancelButtonText: t("cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        masiveDistributionServices
          .deleteVtaFile(item?.id)
          .then(() => {
            Swal.fire(
              t("successDeleteTarascaTitle"),
              t("successDeleteTarascaText"),
              "success",
            ).then(() => {
              getFiles();
              setLoadingDelete({
                id: 0,
                status: false,
              });
            });
          }).catch(() => {
            Swal.fire(t("retry"), t("sorryErrorOcurred"), "error").then(() => {
              setLoadingDelete({
                id: 0,
                status: false,
              });
            });
          });
      } else {
        setLoadingDelete({
          id: 0,
          status: false,
        });
      }
    });
  };

  useEffect(() => {
    getFiles();
  }, [page, pageSize, sort]);

  const handleConcilitation = (id) => {
    deliveryServices
      .concilitation(id)
      .then((data) => {
        const {
          supplierLotteryConcliliated,
          lotteryAgencyConcliliated,
          supplier_lottery,
          lottery_agency,
        } = data

        const conciliationData = {
          supplierLottery: supplierLotteryConcliliated ? undefined : supplier_lottery,
          lotteryAgency: lotteryAgencyConcliliated ? undefined : lottery_agency
        }

        if (!supplierLotteryConcliliated || !lotteryAgencyConcliliated) {
          setConciliationModalData({ conciliationData, open: true })
        }
      }).catch(() => {
        Swal.fire(t("retry"), t("sorryErrorOcurred"), "error")
      });
  }

  return (
    <Grid container className={s.container}>
      {detail.status ? (
        <DetailSalvta detail={detail} setDetail={setDetail} />
      ) : (
        <>
          <Grid item container xs={11} className={s.header}>
            <Grid item xs={12} lg={7} md={8} className={s.titleContainer}>
              <SellIcon sx={{ fontSize: "2rem", color: "primary.main" }} />
              <h4>{t("salvta")}</h4>
            </Grid>
            <Grid item xs={12} lg={2} md={3}>
              <Tooltip placement="top" title={t("uploadFile")}>
                <Button
                  variant="contained"
                  className={s.uploadBtn}
                  onClick={() => setOpen(true)}
                >
                  <UploadRoundedIcon sx={{ fontSize: "2rem" }} />
                </Button>
              </Tooltip>
            </Grid>
          </Grid>

          {loading ? (
            <Grid item xs={11} className={s.loader}>
              <CircularProgress size={"3rem"} />
            </Grid>
          ) : items?.length ? (
            <Grid item container xs={11} className={s.data}>
              <TableContainer className={s.tableContainer}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("processedFile")}
                      >
                        {`${t("archive")} ${sort.field === "processedFile" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("emission")}
                      >
                        {`${t("drawNumber")} ${sort.field === "emission" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "primary.main",
                          "&:hover": { cursor: "pointer" },
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("processDate")}
                      >
                        {`${t("ProcessDate")} ${sort.field === "processDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                      </TableCell>
                      {
                        // <TableCell
                        //   align="center"
                        //   sx={{
                        //     backgroundColor: "primary.main",
                        //     color: textColor,
                        //     fontSize: ".9rem",
                        //     fontWeight: 500,
                        //     fontFamily: "Roboto, sans-Serif",
                        //   }}
                        // >
                        //   Estado Conciliación
                        // </TableCell>
                      }
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        Acciones
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {items.map((item, i) => {
                      return (
                        <React.Fragment key={item.id}>
                          <TableRow
                            key={item.id}
                            sx={{
                              "&:hover": { backgroundColor: "secondary.light" },
                            }}
                          >
                            <TableCell
                              align="center"
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                              onClick={() => handleDetail(item)}
                            >
                              {item.fileName}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                              onClick={() => handleDetail(item)}
                            >
                              {item.raffle.number || "-"}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                              onClick={() => handleDetail(item)}
                            >
                              {dates.formatDate(item.processDate) || "Fecha no disponible"}
                            </TableCell>
                            {

                              // <TableCell
                              //   align="center"
                              //   sx={{
                              //     ...cellStyles,
                              //     backgroundColor:
                              //       i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              //   }}
                              // >
                              //   {item.conciliation ?
                              //     <Brightness1Icon fontSize="small" color="success" /> :
                              //     <Brightness1Icon fontSize="small" color="error" />}
                              // </TableCell>
                            }
                            <TableCell
                              align="center"
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                alignItems: "center",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              {loadingDelete.status &&
                                loadingDelete.id === item.id ? (
                                <CircularProgress size={"2rem"} />
                              ) : (
                                <DeleteForeverRoundedIcon
                                  className={s.iconbtn}
                                  sx={{ color: "primary.dark" }}
                                  onClick={() => handleDelete(item)}
                                />
                              )}
                              {
                                //   {!item.conciliation &&
                                //     <IconButton
                                //       onClick={() => handleConcilitation(item.id)}
                                //       color="primary"
                                //       aria-label="Reconciliar"
                                //     >
                                //       <LoopIcon
                                //         className={s.iconbtn}
                                //       />
                                //     </IconButton>
                                // }
                              }
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          ) : (
            <Grid item xs={12} className={s.noResults}>
              {t("noResults")}
            </Grid>
          )}
          <UploadModal
            open={open}
            setOpen={setOpen}
            getFiles={getFiles}
            setConciliationModal={setConciliationModalData}
          />
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: "50px",
            }}
          >
            <Pager
              pageSize={pageSize}
              setPageSize={setPageSize}
              page={page}
              setPage={setPage}
              totalPages={totalPages}
              pageCustom={pageCustom}
              setPageCustom={setPageCustom}
            />
          </Grid>
          {conciliationModalData.open &&
            <ConciliationModal
              data={conciliationModalData}
              setData={setConciliationModalData}
            />
          }
        </>
      )}
    </Grid>
  );
};

export default ArchivosSalvta;
